import type { AxiosInstance, AxiosRequestConfig } from 'axios'

import type {
  McpConnectionListResponse,
  McpRevokeResponse,
  McpSessionConnectPayload,
  McpSessionConnectResponse,
  McpSessionPreview,
} from '../models/mcp.types'

import { appHttp, unwrap } from '@/shared/http'

export const MCP_CONNECTIONS_PATH = '/api/interaction-gateway/v1/connections/mcp'

const FEATURE_ERRORS: AxiosRequestConfig = {
  suppressGlobalErrorHandler: true,
  meta: { suppressGlobalErrorHandler: true },
}

export class McpConnectionsApi {
  constructor(private readonly http: AxiosInstance = appHttp) {}

  async sessionPreview(sessionToken: string): Promise<McpSessionPreview> {
    return unwrap(
      await this.http.post<McpSessionPreview>(
        `${MCP_CONNECTIONS_PATH}/connect/session/preview`,
        { session_token: sessionToken },
        FEATURE_ERRORS,
      ),
    )
  }

  async sessionConnect(payload: McpSessionConnectPayload): Promise<McpSessionConnectResponse> {
    return unwrap(
      await this.http.post<McpSessionConnectResponse>(
        `${MCP_CONNECTIONS_PATH}/connect/session`,
        payload,
        FEATURE_ERRORS,
      ),
    )
  }

  async list(limit = 50, offset = 0): Promise<McpConnectionListResponse> {
    return unwrap(
      await this.http.get<McpConnectionListResponse>(`${MCP_CONNECTIONS_PATH}/`, {
        params: { limit, offset },
      }),
    )
  }

  async revoke(connectionKey: string): Promise<McpRevokeResponse> {
    return unwrap(
      await this.http.post<McpRevokeResponse>(
        `${MCP_CONNECTIONS_PATH}/${encodeURIComponent(connectionKey)}/revoke`,
        {},
      ),
    )
  }
}
